/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable new-cap */
import { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

interface TextWithReadMoreProps {
  htmlString: string;
  maxLength: number;
}

const TruncateComponent = ({ htmlString, maxLength }: TextWithReadMoreProps): JSX.Element => {
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleTruncate = (): void => {
    setIsTruncated(!isTruncated);
  };

  const truncatedText = htmlString.substring(0, maxLength);

  const contentToShow = isTruncated ? truncatedText : htmlString;

  return (
    <div>
      <span>{ReactHtmlParser(contentToShow) as unknown as JSX.Element}</span>
      <button className="text-primary-intense" onClick={toggleTruncate}>
        {isTruncated ? 'More' : 'Less'}
      </button>
    </div>
  );
};

export default TruncateComponent;
